import { useEffect, useState } from "react";

const STEPS = [
  "INIT",
  "POS_ENTRY",
  "CARD_CAPTURED",
  "DATA_STRUCTURED",
  "ISO_BUILT",
  "ENCRYPTED",
  "ROUTED",
  "AUTHORIZED",
  "COMPLETED"
];

export function useCinematic() {
  const [index, setIndex] = useState(0);
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    if (!isPlaying) return;

    const interval = setInterval(() => {
      setIndex((i) => {
        if (i < STEPS.length - 1) return i + 1;
        setIsPlaying(false);
        return i;
      });
    }, 1800);

    return () => clearInterval(interval);
  }, [isPlaying]);

  return {
    currentIndex: index,
    currentStep: STEPS[index],
    isPlaying,

    next: () =>
      setIndex((i) => Math.min(i + 1, STEPS.length - 1)),

    prev: () =>
      setIndex((i) => Math.max(i - 1, 0)),

    play: () => setIsPlaying(true),
    pause: () => setIsPlaying(false),
    reset: () => setIndex(0)
  };
}